module.exports = __webpack_public_path__ + "static/media/runinc_logo.741795b6.svg";